<template>
  <div v-if="visible" class="golden-ticket-classy">
    <div class="ticket-content">
      <div class="text-block">
        <p class="message">¡Felicidades!</p>
        <p class="subtitle">
          <span class="highlight">Golden Ticket</span>
        </p>
        <p class="amount">{{ amount }}<span class="currency">UND</span></p>
        <p class="custom-message">{{ message }}</p>
        <v-btn
          x-small
          color="black"
          dark
          class="redeem-btn"
          :disabled="isRedeeming"
          @click="redeem"
        >
          <span v-if="!isRedeeming">USAR</span>
          <div v-else-if="hipodromos.length == 0">
            <span class="custom-messages">No existen eventos activos </span><br>
            <span class="custom-messages">Intente mas tarde </span>
          </div>
          <span v-else class="waiting-text">Esperando Jugada...</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoldenTicket",
  props: {
    hasTicket: {
      type: Boolean,
      default: false,
    },
    amount: {
      type: [Number, String],
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    hipodromos: {
      type: Array,
      required: true,
    },
    resetFlag: {
      type: Number, // puede ser un contador
      default: 0,
    },
  },
  data() {
    return {
      visible: this.hasTicket,
      isRedeeming: false,
    };
  },
  watch: {
    hasTicket(val) {
      this.visible = val;
    },
    resetFlag() {
      // se activa cada vez que el padre incrementa el flag
      this.isRedeeming = false;
      this.visible = this.hasTicket;
    },
  },
  methods: {
    redeem() {
      if (this.isRedeeming) return;
      this.isRedeeming = true;
      this.$emit("use-ticket");
    },
    reset() {
      this.isRedeeming = false;
      this.visible = this.hasTicket;
    },
  },
};
</script>

<style scoped>
.golden-ticket-classy {
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  width: 300px;
  /*  background: linear-gradient(135deg, #fdd835, #ffca28);*/
  background: url('https://trackandraces.com/dominio/tr/golden.png') center center / cover no-repeat;
  
  
  padding: 12px 14px 19px;
  font-family: "Poppins", sans-serif;
  z-index: 9999;
  color: #212121;
  animation: bounceIn 0.6s ease-out, shakeLoop 3s infinite;
}

.ticket-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-block {
  text-align: center;
  line-height: 1.1;
  width: 100%;
}

.message {
  font-size: 13px;
  font-weight: 600;
  margin: 0;
  text-transform: uppercase;
  color: #212121;
}

.subtitle {
  font-size: 13px;
  margin: 6px 0 0;
  font-weight: 500;
  color: #3e3e3e;
}

.highlight {
  font-size: 20px;
  font-weight: 900;
  color: #f9ed0a;
  
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.6), 0 0 4px #080808;
  letter-spacing: 0.5px;
}

.amount {
  font-size: 22px;
  font-weight: 800;
  color: #000;
  margin: 4px 0 0;
  letter-spacing: 0.5px;
}

.currency {
  font-size: 13px;
  font-weight: 600;
  color: #060606;
  margin-left: 2px;
}

.custom-message {
  font-size: 12px;
  font-style: italic;
  color: #060606;
  margin: 6px 0 10px;
  line-height: 1.3;
}
.custom-messages {
  font-size: 10px;
  font-style: italic;
  color: #060606;
  margin: 6px 0 10px;
  line-height: 1.3;
}

.redeem-btn {
  margin-top: 3px;
  margin-bottom: 3x;
}

.waiting-text {
  color: #0d47a1 !important; /* Azul oscuro */
  font-weight: 600;
}

/* ANIMACIONES */
@keyframes bounceIn {
  0% {
    transform: translateX(-50%) scale(0.7);
    opacity: 0;
  }
  60% {
    transform: translateX(-50%) scale(1.1);
    opacity: 1;
  }
  80% {
    transform: translateX(-50%) scale(0.95);
  }
  100% {
    transform: translateX(-50%) scale(1);
  }
}

@keyframes glow {
  0%,
  100% {
    text-shadow: 0 0 4px #fff, 0 0 10px #ff1744, 0 0 20px #ff1744;
  }
  50% {
    text-shadow: 0 0 8px #fff, 0 0 15px #ff1744, 0 0 30px #ff1744;
  }
}

@keyframes shakeLoop {
  0%,
  33.33%,
  100% {
    transform: translateX(-50%) translateY(0);
  }
  5% {
    transform: translateX(-50%) translateY(-2px);
  }
  10% {
    transform: translateX(-50%) translateY(2px);
  }
  15% {
    transform: translateX(-50%) translateY(-2px);
  }
  20% {
    transform: translateX(-50%) translateY(2px);
  }
  25% {
    transform: translateX(-50%) translateY(-2px);
  }
  30% {
    transform: translateX(-50%) translateY(0);
  }
}

/* RESPONSIVE */
@media (max-width: 600px) {
  .golden-ticket-classy {
    bottom: 70px;
    width: 90%; /* más flexible que fijo en px */
    max-width: 290px; /* evita que se haga demasiado grande en tablet */
    padding: 10px 10px 10px;
    background-size: cover; /* asegúrate de que cubra bien en pantallas chicas */
    background-position: center;
  }

  .amount {
    font-size: 18px;
  }

  .subtitle,
  .message {
    font-size: 12px;
  }
  

  .highlight {
    font-size: 15px;
  }

  .custom-message,
  .custom-messages {
    font-size: 11px;
  }

  .redeem-btn {
    font-size: 11px;
  }
}
</style>
